export default "__VITE_ASSET__YxGclsXQ__"